import { NotePlayer } from "../../Sound/NotePlayer"
import { Angles } from "../../Util/Math/Angles"
import { Chords } from "../../Util/Music/Chords"
import { HexMap } from "./HexMap"
import { Key } from "./Key"
import { KeyRelationship, Note } from "./Note"

export function getNearestParentKey(note:Note, e:React.MouseEvent){
            const left:number = e.currentTarget.getBoundingClientRect().left
            const top:number = e.currentTarget.getBoundingClientRect().top
            const height:number = e.currentTarget.getBoundingClientRect().height
            const width:number = e.currentTarget.getBoundingClientRect().width
            const centerx:number = left + (width/2)
            const centery:number = top + (height/2)
            const angle:any = (Angles.getAngleFromPoints(centerx, centery, e.clientX, e.clientY) + 90 + 360) % 360
            if(note.getPositionType() === Note.PositionTypeOdd){
                if(angle > 0 && angle < 120){
                    // its the mixolydian
                    return([getKeyIndexByPosition(note, 4), 4])
                }
                if(angle > 120 && angle < 240){
                    // its the ionian
                    return([getKeyIndexByPosition(note, 0), 0])
                }
                if(angle > 240 && angle < 360){
                    // its phrygian
                    return([getKeyIndexByPosition(note, 2), 2])
                }
            }
            if(note.getPositionType() === Note.PositionTypeEven){
                if((angle > 0 && angle < 60) || (angle > 300 && angle < 360)){
                    //console.log('aeolian')
                    return([getKeyIndexByPosition(note, 5), 5])
                }
                if(angle > 60 && angle < 180){
                    //console.log('lydian')
                    return([getKeyIndexByPosition(note, 3), 3])
                }
                if(angle > 180 && angle < 300){
                    //console.log('dorian')
                    return([getKeyIndexByPosition(note, 1), 1])
                }
            }
            if(note.getPositionType() === Note.PositionTypeSeven){
                return([getKeyIndexByPosition(note, 6), 6])
            }
            return([-1,-1])

}
export function getKeyIndexByPosition(note:Note, position:number){
    const keyRel:KeyRelationship|undefined = note.keys.find((kr:KeyRelationship)=>{
        return(kr.position === position)
    })
    if(keyRel){
        return keyRel.keyIndex
    }
    return -1
}
export function playChord(rootNote:Note, formula:number[], e:React.MouseEvent, map:HexMap, notePlayer:NotePlayer){
        const [keyIndex, position] = getNearestParentKey(rootNote, e)
        const key:Key = map.keys.flat()[keyIndex]
        if(!key){console.error('no key with that index'); return}
        const notes:number[] = Chords.GetChordNoteTonics(key.params.tonic, position, formula)
        notePlayer.playChord(notes, true)
        notePlayer.reset()
}